module.exports = __webpack_public_path__ + "img/idebit.11a028b9.svg";